import { render, staticRenderFns } from "./ownerdesk.vue?vue&type=template&id=199553a2&scoped=true&"
import script from "./ownerdesk.vue?vue&type=script&lang=js&"
export * from "./ownerdesk.vue?vue&type=script&lang=js&"
import style0 from "./ownerdesk.vue?vue&type=style&index=0&id=199553a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199553a2",
  null
  
)

export default component.exports